
export default function Hero() {
  return (
    <section id="home" className="min-h-screen flex items-center pt-20">
      <div className="w-full max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 min-h-[calc(100vh-80px)]">
          {/* Left Content Panel */}
          <div className="bg-white flex flex-col justify-center py-20 lg:py-32 px-8 lg:px-16 relative">
            <div className="absolute top-12 left-8 w-0.5 h-16 bg-teal-500"></div>
            <div className="inline-block mb-8">
              <span className="inline-block px-4 py-2 bg-teal-50 text-teal-600 text-xs font-medium uppercase tracking-wider rounded-lg">
                iOS Development Experts
              </span>
            </div>
            <h2 className="text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-8">
              Modern<br />
              <span className="text-gray-400">/</span> Applications<br />
              <span className="text-gray-400">/</span> for iOS
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed max-w-md">
              METOS DOO NIS is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>

          {/* Right Visual Panel */}
          <div className="relative bg-gradient-to-br from-slate-100 via-teal-50 to-amber-50 flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-black/5"></div>
            <div className="relative w-full h-full flex items-center justify-center p-12">
              <img 
                src="https://public.readdy.ai/ai/img_res/38901c137e88bac01685db071688088e.jpg"
                alt="iOS Application Interface"
                className="w-full h-full object-contain drop-shadow-2xl"
              />
              <div className="absolute top-20 right-20 w-64 h-64 bg-teal-400/20 rounded-3xl blur-3xl"></div>
              <div className="absolute bottom-32 left-20 w-48 h-48 bg-amber-300/20 rounded-3xl blur-3xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}